import { createContext } from "react"

export type Theme = "dark" | "white" | "gold"

export const ThemeContext = createContext<Theme>("dark")
